import React, {Fragment} from 'react';

const PostComment = ({handleOnChange, handlePostComment, comment}) => {
  return (
    <Fragment>
    <div style={{borderTop: '1px solid rgba(0,0,0,0.12)', margin: '50px 0px'}}/>
      <form>
        <div className="row">
          <div className="col-lg-9 col-md-9 col-sm-12 col-12">
            <textarea className="form-control" name="" id="" rows="2" placeholder="Tulis komentar" style={{padding: '20px'}} onChange={(e) => handleOnChange(e)}/>
          </div>
          <div className="col-lg-3 col-md-3 col-sm-12 col-12">
            <button type='submit' className="btn btn-blue mt-3 w-100" style={{padding: '10px 25px !important'}} disabled={comment === '' ? true : false} onClick={() => handlePostComment()}>
              Beri Komentar
            </button>
          </div>
        </div>
      </form>
      <div style={{borderTop: '1px solid rgba(0,0,0,0.12)', margin: '50px 0px'}}/>
      </Fragment>
  )
}

export default PostComment